import { extend } from 'vee-validate';
import { min } from 'vee-validate/dist/rules';

extend('min', min);
